import { render } from "./PasswordValidator.vue?vue&type=template&id=5afcbc20&scoped=true"
import script from "./PasswordValidator.vue?vue&type=script&lang=js"
export * from "./PasswordValidator.vue?vue&type=script&lang=js"

import "../../assets/css/Elements/PasswordValidator.css?vue&type=style&index=0&id=5afcbc20&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5afcbc20"]])

export default __exports__